import { ApiRequest } from './requests';
import { CueResponse } from '../models/common';

export interface ExchangeLoginPhoenixRequestBM {
  code: string;
  id: string;
  pairingUID?: string;
}

export interface ExchangeLoginPhoenixResponseBM {
  id: string;
  email: string;
  username: string;
  token: string;
  refreshToken: string;
}

export interface LoginPhoenixRequestBM {
  email: string;
  pairingUID?: string;
}

export interface UserHasPasswordRequestBM {
  email: string;
}

export interface UserHasPasswordResponseBM {
  hasPassword: boolean;
}

export interface UserLoginRequestBM {
  email: string;
  password: string;
}

export interface UserForgottenPasswordRequestBM {
  email: string;
}

export interface UserResetPasswordRequestBM {
  email: string;
  token: string;
  password: string;
}

export interface SetUserPasswordRequestBM {
  oldPassword?: string;
  password: string;
}

export interface LinkedAccountResponseBM {
  id: string;
  alias: string;
  pairedDate: string;
  connectionAgentId: number | null;
  email: string | null;
}

export function emailLogin(email: string, pairingUid?: string): ApiRequest<LoginPhoenixRequestBM, string> {
  return {
    url: '/api/account/email-login',
    payload: {
      email: email,
      pairingUID: pairingUid,
    },
    method: 'post',
  };
}

export function unpairLinkedAccounts(id: string): ApiRequest<any, any[]> {
  return {
    url: '/api/account/linked-accounts/' + id,
    method: 'delete',
  };
}

export function getLinkedAccounts(): ApiRequest<any, LinkedAccountResponseBM[]> {
  return {
    url: '/api/account/linked-accounts',
    method: 'get',
  };
}

export function exchangeEmailLogin(
  request: ExchangeLoginPhoenixRequestBM
): ApiRequest<ExchangeLoginPhoenixRequestBM, ExchangeLoginPhoenixResponseBM> {
  return {
    url: '/api/account/exchange-email-login',
    payload: request,
    method: 'post',
  };
}

export function userLogin(
  request: UserLoginRequestBM
): ApiRequest<{ data: UserLoginRequestBM }, CueResponse<{ token: string; refreshToken: string }>> {
  return {
    url: '/api/account/user-login',
    payload: {
      data: request,
    },
    method: 'post',
  };
}

export function userHasPassword(
  request: UserHasPasswordRequestBM
): ApiRequest<{ data: UserHasPasswordRequestBM }, CueResponse<UserHasPasswordResponseBM>> {
  return {
    url: '/api/account/user-has-password',
    payload: {
      data: request,
    },
    method: 'post',
  };
}

export function userForgottenPassword(
  request: UserForgottenPasswordRequestBM
): ApiRequest<{ data: UserForgottenPasswordRequestBM }, CueResponse<void>> {
  return {
    url: '/api/account/user-forgotten-password',
    payload: {
      data: request,
    },
    method: 'post',
  };
}

export function userResetPassword(
  request: UserResetPasswordRequestBM
): ApiRequest<{ data: UserResetPasswordRequestBM }, CueResponse<void>> {
  return {
    url: '/api/account/user-reset-password',
    payload: {
      data: request,
    },
    method: 'post',
  };
}

export function setUserPassword(
  request: SetUserPasswordRequestBM
): ApiRequest<{ data: SetUserPasswordRequestBM }, CueResponse<void>> {
  return {
    url: '/api/account/set-user-password',
    payload: {
      data: request,
    },
    method: 'post',
  };
}
